import { useEffect } from "react";

export default function useEvent(eventName, callback) {
  useEffect(() => {
    document.addEventListener(eventName, callback, false);
    return () => {
      document.removeEventListener(eventName, callback, false);
    };
  }, []);

  return { dispatchEv: () => document.dispatchEvent(new Event(eventName)) };
};
